const extend = require('lodash/extend');

const DEFAULT_CONFIG = require('./config.default');
const REGION_CONFIG = require('./config.' + DEFAULT_CONFIG.REGION.toLowerCase());

module.exports = extend({}, DEFAULT_CONFIG, REGION_CONFIG);
